import React from 'react';
import { FaRegEyeSlash, FaRegEye } from 'react-icons/fa';
import { UserManager } from 'oidc-client-ts';

class SignIn extends React.Component {
  constructor(props) {
    super(props);
    this.userManager = null;
    this.state = {
      user: {
        email: '',
        password: '',
      },
      passwordVisible: false,
      csrfToken: (document.querySelector('meta[name=csrf-token]') || {}).content,
      processingLogin: false,
    };
  }

  async componentDidMount() {
    const settings = {
      authority: this.props.oidc_issuer,
      client_id: this.props.oidc_client_id,
      redirect_uri: `${window.location.origin}/login`,
      response_type: 'code',
      scope: 'openid profile email',
    };

    this.userManager = new UserManager(settings);
    console.log(this.userManager);

    const url = window.location.href;
    if (url.includes('code=') && url.includes('state=')) {
      this.setState({ processingLogin: true });

      try {
        const user = await this.userManager.signinRedirectCallback();
        const accessToken = user.access_token;
        window.location.href = `/auth/oidc/callback?access_token=${accessToken}`;
      } catch (err) {
        console.error('OIDC login failed', err);
      }
    }
  }

  handleLogin = () => {
    if (this.userManager) {
      this.userManager.signinRedirect();
    }
  };

  handleChange = (e) => {
    const { user } = this.state;
    this.setState({ user: { ...user, [e.target.id]: e.target.value } });
  };

  render() {
    const { url, forgotPasswordPath, flash } = this.props;
    const {
      user, passwordVisible, csrfToken, processingLogin,
    } = this.state;
    const subdomain = window.location.hostname.split('.')[0];
    const isMMC = subdomain.toLowerCase() === 'mmc';

    return (
      <div className="auth-page new-login">
        <form action={url} method="post" className="login-form">
          <img src="/logo_dark.svg" className="trademark-header" />
          {processingLogin && (
            <div className="alert alert-info">
              Working on your login...
            </div>
          )}
          {flash.map(([type, message]) => (
            <div className="alert alert-warning" key={type}>
              <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
              {message}
            </div>
          ))}
          {!isMMC ? (
            <>
              <div className="form-group">
                <label className="control-label" htmlFor="email">Email</label>
                <input
                  className="form-control"
                  type="email"
                  name="user[email]"
                  id="email"
                  value={user.email}
                  onChange={this.handleChange}
                  placeholder="example@email.com"
                />
              </div>
              <div className="form-group">
                <label className="control-label" htmlFor="password">Password</label>
                <div className="input-group">
                  <input
                    className="form-control"
                    type={passwordVisible ? 'text' : 'password'}
                    name="user[password]"
                    value={user.password}
                    onChange={this.handleChange}
                    id="password"
                  />
                  <span className="input-group-addon" onClick={() => this.setState({ passwordVisible: !passwordVisible })}>
                    {passwordVisible ? <FaRegEye /> : <FaRegEyeSlash />}
                  </span>
                </div>
              </div>

              <a className="forgot-password-link" href={forgotPasswordPath}>Forgot Password</a>

              <input type="hidden" name="authenticity_token" value={csrfToken} />
              <button type="submit" className="btn btn-submit">Sign In</button>

              <div className="form-footer">
                Don’t have an account yet?
                {' '}
                <a href="https://minerva26.com/contact-us/">Register</a>
              </div>
            </>
          ) : (
            <button type="button" className="btn btn-submit" onClick={this.handleLogin} style={{ marginTop: '4rem' }}>
              Sign In with OIDC
            </button>
          )}

          <div className="form-footer">
            <a href="/terms_of_use">Terms and Conditions</a>
            &nbsp; &nbsp;
            <a href="/privacy-policy">Privacy Policy</a>
          </div>
        </form>
      </div>
    );
  }
}

export default SignIn;
